import request from '../config/axiosConfig';
import { GET_LIST_LESSONS, GET_LESSON_INFO, CREATE_LESSON, UPDATE_LESSON, DELETE_LESSON, GET_ALL_LESSONS } from '../constants/lessonApiEndPoint';

export const getLessons = async (params) => {
  return (await request({
    url: GET_LIST_LESSONS,
    method: 'GET',
    params,
  }))?.data;
};

export const getAllLessons = async () => {
  return (await request({
    url: GET_ALL_LESSONS,
    method: 'GET',
  }))?.data;
};

export const getLessonInfo = async (id) => {
  return (await request({
    url: GET_LESSON_INFO,
    method: 'GET',
    params: { id },
  }))?.data;
};

export const createLesson = async (data) => {
  return (await request({
    url: CREATE_LESSON,
    method: 'POST',
    data,
  }))?.data;
};

export const updateLesson = async (id, data) => {
  return (await request({
    url: UPDATE_LESSON,
    method: 'POST',
    params: { id },
    data,
  }))?.data;
};

export const deleteLesson = async (id) => {
  return (await request({
    url: DELETE_LESSON,
    method: 'DELETE',
    params: { id },
  }))?.data;
};
